{
  "version": 1,
  "asset_id": "7f5ef9db-6abe-4b8d-814d-dd84cfb4d077",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7f5ef9db-6abe-4b8d-814d-dd84cfb4d077/sleeve-fitzer-3-220.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7f5ef9db-6abe-4b8d-814d-dd84cfb4d077/sleeve-fitzer-3-220.webp",
  "original_filename": "sleeve-fitzer-3-220.webp",
  "size": 3296,
  "content_type": "image/webp",
  "created_at": "2026-09-29T01:15:23Z"
}
